import {inject, Injectable} from "@angular/core";
import {FarmApiClient} from "src/app/infrastructure/moovement-api/web-api/farm.api-client";
import {DataStorageService} from "src/app/infrastructure/data-storage.service";
import {Device, SynchronizationStatus} from "src/app/infrastructure/moovement-api/models/asset";
import {DeviceStore} from "src/app/domain/devices/device.store";
import {DataType} from "src/app/domain/domain-models";

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  private deviceStore = inject(DeviceStore);

  constructor(
    private farmApiClient: FarmApiClient,
    private dataStorageService: DataStorageService
  ) {}

  reset() {
    this.deviceStore.reset();
  }

  loadDevices(farmId: string): void {
    this.farmApiClient.getDevices(farmId).subscribe({
      next: async devices => {
        for (const device of devices) {
          await this.persist(device);
        }
        this.deviceStore.setAllEntities(devices);
      },
      error: async () => {
        const cachedDevices = await this.dataStorageService.getAllActiveAssetsMatching<Device>(DataType.devices, farmId);
        this.deviceStore.setAllEntities(cachedDevices);
      }
    });
  }

  private async persist(device: Device) {
    await this.dataStorageService.saveAsset(DataType.devices, device.farmId, device, SynchronizationStatus.upToDate);
  }
}
